import {
    FORGOT_PASSWORD,
    FORGOT_PASSWORD_SUCCESS,
    FORGOT_PASSWORD_FAILED,
    FORGOT_PASSWORD_VERIFY_OTP,
    FORGOT_PASSWORD_VERIFY_OTP_SUCCESS,
    FORGOT_PASSWORD_VERIFY_OTP_FAILED,
    RESET_PASSWORD,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILED,
    CANCEL_FORGOT_PASSWORD,
} from "constants/ActionTypes";

const INIT_STATE = {
    loader: false,
    email: '',
    email_verifying: false,
    email_verified: false,
    otp: '',
    otp_verifying: false,
    otp_verified: false,
    password_resetting: false,
    password_reset: false,
    error_details: null
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FORGOT_PASSWORD: {
            return {
                ...state,
                loader: true,
                email_verifying: true,
                error_details: false,
            }
        }
        case FORGOT_PASSWORD_SUCCESS: {
            return {
                ...state,
                loader: false,
                email_verifying: false,
                email_verified: true,
                error_details: false,
            }
        }
        case FORGOT_PASSWORD_FAILED: {
            return {
                ...state,
                loader: false,
                email_verifying: false,
                error_details: action.payload,
            }
        }
        case FORGOT_PASSWORD_VERIFY_OTP: {
            return {
                ...state,
                loader: true,
                otp_verifying: true,
                error_details: false,
            }
        }
        case FORGOT_PASSWORD_VERIFY_OTP_SUCCESS: {
            return {
                ...state,
                loader: false,
                otp_verifying: false,
                otp_verified: true,
                error_details: false,
            }
        }
        case FORGOT_PASSWORD_VERIFY_OTP_FAILED: {
            return {
                ...state,
                loader: false,
                otp_verifying: false,
                error_details: action.payload,
            }
        }
        case RESET_PASSWORD: {
            return {
                ...state,
                loader: true,
                password_resetting: true,
                error_details: false,
            }
        }
        case RESET_PASSWORD_SUCCESS: {
            return {
                ...state,
                loader: false,
                password_resetting: false,
                password_reset: true,
                error_details: false,
            }
        }
        case RESET_PASSWORD_FAILED: {
            return {
                ...state,
                loader: false,
                password_resetting: false,
                error_details: action.payload,
            }
        }
        case CANCEL_FORGOT_PASSWORD: {
            return {
                ...state,
                loader: false,
                email_verifying: false,
                email_verified: false,
                otp: '',
                otp_verifying: false,
                otp_verified: false,
                password_resetting: false,
                password_reset: false,
                error_details: null
            }
        }
        default:
            return state;
    }
}
